import { writable } from 'svelte/store';

export const staffMember = writable(0);

export const roomRequest = writable(0);

export const isDebug = writable(0);